import { render, staticRenderFns } from "./ChatOverlay.vue?vue&type=template&id=350b9158&scoped=true"
import script from "./ChatOverlay.vue?vue&type=script&lang=js"
export * from "./ChatOverlay.vue?vue&type=script&lang=js"
import style0 from "./ChatOverlay.vue?vue&type=style&index=0&id=350b9158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b9158",
  null
  
)

export default component.exports